import { render, staticRenderFns } from "./approvaling.vue?vue&type=template&id=1481d93a&scoped=true&"
import script from "./approvaling.vue?vue&type=script&lang=js&"
export * from "./approvaling.vue?vue&type=script&lang=js&"
import style0 from "./approvaling.vue?vue&type=style&index=0&id=1481d93a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1481d93a",
  null
  
)

export default component.exports